import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import ErrorBoundary from '@/components/ErrorBoundary';
import { registrarErro } from '@/lib/erros';
import '@/styles/global.css';

/**
 * ★★★ WT lote 1 — OS DOIS GANCHOS GLOBAIS.
 *
 * ⚠⚠ O `ErrorBoundary` pega erro de RENDER. Ele não pega:
 *   - erro dentro de `setTimeout`, de handler de evento ou de qualquer código fora do render;
 *   - **promessa rejeitada sem `catch`** — que é onde caem os 11 tratadores `() => {}` e os
 *     `.catch(() => {})` que a medição achou (`docs/wt-medicao.md` §1.2).
 *
 * ★ Então os dois ganchos existem, e cada um cobre o que o outro não vê.
 * ⚠ Nenhum deles interrompe o comportamento padrão do navegador: só registram.
 */
window.addEventListener('error', (evento) => {
  registrarErro({
    origem: 'global',
    codigo: evento?.error?.name ?? 'erro-global',
    mensagem: evento?.error?.message ?? evento?.message ?? '',
  });
});

window.addEventListener('unhandledrejection', (evento) => {
  const r = evento?.reason;
  registrarErro({
    origem: 'global',
    // ★ `code` primeiro: promessa rejeitada por rule vem com `permission-denied`, e é
    // exatamente o caso que a medição quer ver chegar ao superadmin.
    codigo: r?.code ?? r?.name ?? 'promessa-rejeitada',
    mensagem: r?.message ?? String(r ?? ''),
  });
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
